@if (showPartEmployee()) {
	<div class="employee-description">
		<div class="radio-row form-row">
			<div class="radio-column">
				<nb-radio id="part-time-employees-included-{{product.standard.name}}" [name]="'partTimeEmployeesIncluded' + standardName() + rand()" [checked]="true" status="primary">
					{{ product.partTimeOrTempEmployeesIncluded | booleanDisplay }}
				</nb-radio>
			</div>
			<div class="radio-description-column">
				{{ 'company-general-info.employees-count-description' | translate }}
				<change-label [visible]="areEmployeeDetailsChanged()" [changeSet]="changeSet"></change-label>
			</div>
		</div>
		@if (product.partTimeOrTempEmployeesIncluded) {
			<div id="employee-description-{{product.standard.name}}" class="client-property">
				{{ product.employeesCountDescription }}
				@if (translationsHelper.translationExists(product.standard.name, 'employeesCountDescription', useOriginalTranslations)) {
					<translation-field [standard]="standardName()" [previewMode]="!translateClientsData"
									   [translatedText]="translationsHelper.getTranslation(product.standard.name, 'employeesCountDescription', useOriginalTranslations)"
									   [translationSubject]="'employeesCountDescription'"></translation-field>
				}
			</div>
		}
	</div>
}

<div class="client-property-label">
	<span>{{ 'company-general-info.shifts-number.label' | translate }}</span>
	<change-label [visible]="areShiftsChanged()" [changeSet]="changeSet"></change-label>
</div>

<div id="number-of-shifts-{{product.standard.name}}" class="client-property">
	{{ product.shifts }}
</div>
